/*
 * Recherche textuelle partagée par le portail et les écrans d'administration.
 *
 * Insensible à la casse ET aux accents : « pole », « Pôle » et « POLE » doivent
 * remonter les mêmes résultats. Multi-termes et conjonctive : « suivi chantier »
 * ne garde que les entrées contenant les deux mots, dans n'importe lequel des
 * champs fournis et dans n'importe quel ordre.
 */

export const normalize = (value) => (value || '')
  .toString()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

// Rend un prédicat qui reçoit les champs à fouiller : correspond(nom, description, ...).
// Une requête vide rend un prédicat toujours vrai, pour éviter d'avoir à tester
// la présence d'une recherche à chaque appel.
export const makeMatcher = (query) => {
  const termes = normalize(query).split(' ').filter(Boolean);
  if (termes.length === 0) return () => true;
  return (...champs) => {
    const foin = normalize(champs.filter(Boolean).join(' '));
    return termes.every(t => foin.includes(t));
  };
};
